import { Alert, App, Select } from "antd";
import { useEffect, useState } from "react";
import { IMPREZA_BUTTON_PROPS, _i, __ } from "../../../utils";
import { useAccountSubscriptionCancellationReason, useRealCommerceErrorHandling } from "../../../hooks";
import { RealCommerceError } from "../../../exceptions";
const CancellationForm = _ref => {
  var _cancellationReasons$;
  let {
    record,
    onClose,
    modal
  } = _ref;
  const {
    modal: antdModal
  } = App.useApp();

  // Confirmation B should only be shown for Real Cookie Banner (ID: 1) as product
  const isProductRcb = String(record.data.productPlan.product.id) === "1";
  const [cancellationReason, setCancellationReason] = useState();
  const cancellationReasons = useAccountSubscriptionCancellationReason();
  const cancellationReasonHint = (_cancellationReasons$ = cancellationReasons[cancellationReason]) === null || _cancellationReasons$ === void 0 ? void 0 : _cancellationReasons$.hint;
  const handleRealCommerceError = useRealCommerceErrorHandling();
  useEffect(() => {
    modal.update({
      okButtonProps: {
        ...IMPREZA_BUTTON_PROPS,
        onClick: async e => {
          e.preventDefault();
          antdModal.confirm({
            title: __("Are you sure you want to irrevocably cancel your contract?"),
            cancelText: __("Continue without cancellation"),
            okText: __("Cancel now"),
            onCancel: () => {
              modal.destroy();
            },
            onOk: () => {
              modal.update({
                okButtonProps: {
                  ...IMPREZA_BUTTON_PROPS,
                  loading: true
                }
              });
              setTimeout(async () => {
                try {
                  console.log(cancellationReason);
                  await record.cancel({
                    cancellationReason
                  });
                  modal.destroy();
                  onClose === null || onClose === void 0 ? void 0 : onClose();
                } catch (e) {
                  if (e instanceof RealCommerceError) {
                    handleRealCommerceError(e);
                  }
                }
              }, 0);
            }
          });
        }
      }
    });
  }, [cancellationReason]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, _i(__("It's a pity that you want to cancel. Do you have a problem with our software? Then {{a}}open a support ticket{{/a}} and we will help you to solve the problem in a timely manner!"), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/support/"),
      target: "_blank",
      rel: "noreferrer"
    })
  })), /*#__PURE__*/React.createElement("p", null, _i(__("If you cancel now, your licenses will be {{strong}}permanently deactivated{{/strong}} at the end of the current contract period."), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement(Select, {
    style: {
      display: "block"
    },
    placeholder: __("Why are you canceling? (optional)"),
    onChange: value => setCancellationReason(value)
  }, Object.keys(cancellationReasons).map(key => /*#__PURE__*/React.createElement(Select.Option, {
    key: key,
    value: cancellationReasons[key]["name"]
  }, cancellationReasons[key]["localized"]))), !!cancellationReasonHint && /*#__PURE__*/React.createElement(Alert, {
    style: {
      marginTop: 10
    },
    message: cancellationReasonHint
  }), /*#__PURE__*/React.createElement("p", null, __("I am aware of the following consequences of cancellation, which I accept:")), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, _i(__("Yes, I want to {{strong}}lose all benefits{{/strong}} of %s. This also means that I no longer receive important updates.", record.data.productPlan.name), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), isProductRcb && /*#__PURE__*/React.createElement("li", null, _i(__("I am aware that my website may not be privacy compliant without an up-to-date cookie banner. I take the {{strong}}risk of high fines{{/strong}} due to data protection violations."), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("I know that I {{strong}}can not revoke my cancellation{{/strong}}. It may not be possible to purchase %s again at the same price if prices have increased in the meantime.", record.data.productPlan.name), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("{{strong}}For cancelled subscriptions no upgrade or downgrade of the plan is possible anymore. {{/strong}} Revocation of the cancellation is not possible!"), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  }))));
};
export { CancellationForm };